import { getBackendUrl } from "@Utils";
import { getUrlForImage } from "../cubeComponent/constants/globalFunctions";
import axiosWrapper from "../services/axiosWrapper";
import { Query } from "@syncfusion/ej2-data";
import { getDataManagerObj, includedProjectsUrl } from "../services/dataManager";
import { setProjectData, setSpaceData } from "../reducers/breadcrumbsdata";

export function getCurrProjectData(id: any) {
  return async (dispatch: any) => {
    const query = new Query().where("_id", "equal", id);
    let response: any = await getDataManagerObj(includedProjectsUrl).executeQuery(query);
    response = response.result[0];

    if (response?.image != "") {
      dispatch(
        setProjectData({
          ...response,
          projectImageUrl: getUrlForImage({ id }, "projectImage"),
        }),
      );
    } else {
      dispatch(setProjectData({ ...response }));
    }
  };
}

export function getCurrSpaceData(id: any) {
  return (dispatch: any) => {
    axiosWrapper
      .get(`${getBackendUrl()}/spaces/getSpaceById/${id}`)
      .then((res: any) => {
        const spaceData = res.data;
        return spaceData;
      })
      .then((res: any) => dispatch(setSpaceData(res.data)))
      .catch(() => {
        /* noop */
      });
  };
}

export function getSpaceDataBySpaceId(id: any) {
  return async (dispatch: any) => {
    axiosWrapper
      .get(`${getBackendUrl()}/spaces/getSpaceById/${id}`)
      .then((res: any) => {
        dispatch(setSpaceData(res.data));
      })
      .catch((err: any) => console.log("ERROR IN GETSPACEDATABYSPACEID ", err));
  };
}
